import {
  Box,
  TextField,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import PopupForm from "../../Components/PopupForm";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toastify";
import CustomeSelectField from "../../Components/CustomeSelectField";
import CustomTextField from "../../Components/CustomTextField";
import Cookies from "universal-cookie";
import axios from "../../assets/js/AxiosInterceptors";
import { useTranslation } from "react-i18next";
import host from "../../assets/js/Host";
import { FilePicker } from "evergreen-ui";

const cookies = new Cookies();
const RenderContent = (props) => {
  const [t] = useTranslation("common");
  const maintheme = useSelector((state) => state.themeData.maintheme);
  return (
    <Box
    className="ContainerStatusCloseForm"
      sx={{
        "& .MuiFormControl-root": {
          width: "100%",
        },
        "& .MuiFormGroup-root": {
          width: "100%",
        },
        "& .MuiFormControlLabel-root": {
          height: "55px",
          backgroundColor: "#fff",
          boxShadow: "0 0 7px -2px rgba(0,0,0,0.4)",
          borderLeft: "5px solid #1e6a99",
          marginTop: "10px",
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        '& .MuiDialogContent-root':{
          padding:'20px 0px 20px 24px !important'
        },
      }}
    >
      <FormControl>
        {/* <FormLabel id="demo-radio-buttons-group-label">Closing statuses</FormLabel> */}
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue="female"
          name="radio-buttons-group"
          value={props?.selectedStatus}
          onChange={(e) => {
            console.log("status changed", e?.target?.value);
            props?.setSelectedStatus(e?.target?.value);
          }}
        >
          {props?.statuses &&
            props?.statuses?.length > 0 &&
            props?.statuses?.map((itm) => (
              <FormControlLabel
                value={itm?.id}
                control={<Radio />}
                label={itm?.name}
              />
            ))}
        </RadioGroup>
      </FormControl>
    </Box>
  );
};

const RenderFooter = (props) => {
  const gridtheme = useSelector((state) => state.themeData.gridtheme);
  const [t] = useTranslation("common");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box display="flex">
          <Button
            variant="outlined"
            // spacing={2}
            sx={{
              width: "50% !important",
              // flexGrow: 1,
              minWidth: "80px !important",
              maxWidth: "80px !important",
              margin: 1,
              backgroundColor: "#f7f7f7",
              borderColor: gridtheme?.colorWhite,
              color: gridtheme?.colorblack,
              boxShadow: "0 0 7px -2px white",
              //   color:SearchButtonTheme?.clear_button_text_color,
              "&:hover": {
                backgroundColor: "#f7f7f7",
                borderColor: gridtheme?.colorWhite,
                color: gridtheme?.colorblack,
                boxShadow: "0 0 7px 1px white",
                boxShadow: "0",
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterClear"
            color="secondary"
            onClick={() => {
              props.setOpen(false);
            }}
          >
            {"Close"}
          </Button>
          <Button
            variant="contained"
            // spacing={2}
            sx={{
              // flexGrow: 1,
              margin: 1,
              width: "80px !important",
              minWidth: "80px !important",
              maxWidth: "80px !important",
              "&:hover": {
                //   backgroundColor:SearchButtonTheme?.search_button_color+'88',
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterSearch"
            onClick={() => {
              props.submit();
            }}
          >
            {"Save"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default function SelectClosingStatus2(props) {
  const [t] = useTranslation("common");
  const [loading, setLoading] = useState(false);
  const [scroll, setScroll] = React.useState("paper");
  const [statuses, setStatuses] = useState([]);
  const handleClickOpen = (scrollType) => () => {
    props.setOpenDialog(true);
    setScroll(scrollType);
  };

  const handleClose = () => {
    props.setOpenDialog(false);
  };

  const handleHide = () => {
    props.setisLoadPanelVisible(false);
  };

  const changeselectedClosingStatus = (event) => {
    console.log(event.value);
    props.setSelectedClosingStatus(event.value);
  };

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (props.openDialog) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
    //console.log(props.closingStatuses)
  }, [props.openDialog, props.closingStatuses]);

  useEffect(() => {
    setStatuses(props?.closingStatuses);
  }, [props?.closingStatuses, props.selectedClosingStatus]);

  return (
    <PopupForm
      open={props.addForm}
      setOpen={props.setAddForm}
      title={"Closing statuses"}
      width="40%"
      dialogContentPadding="0px 0px 0px 24px !important"
      content={
        <RenderContent
          loading={loading}
          statuses={statuses}
          setSelectedStatus={props?.setSelectedClosingStatus}
          selectedStatus={props?.selectedClosingStatus}
          setLoading={setLoading}
          open={props.addForm}
          setOpen={props.setAddForm}
        />
      }
      footer={
        <RenderFooter
          open={props.addForm}
          setOpen={props.setAddForm}
          submit={props.onSave}
        />
      }
    />
  );
}
